<script lang="ts">
  // Was ein „Läuft gerade"-Eintrag zeigt (Statusleiste, Telefon-Zeile):
  // Claude nur mit Namen und Zahl („Claude 2"), den Zustand trägt der Punkt
  // davor (Tim 19.10.2026: „Der orangene Punkt und Claude reicht"); der
  // Drucker als Text („P1S 51 % · 16:56"). Der ganze Satz steht im
  // aria-label.
  import { buendelText, type Buendel } from "./laeuft";

  let { b, jetzt }: { b: Buendel; jetzt: Date } = $props();
  const kurz = $derived(buendelText(b, jetzt));
  const ganz = $derived(buendelText(b, jetzt, true));
</script>

<span class="truncate" aria-label={ganz !== kurz ? ganz : undefined}>{kurz}</span>
